export const NOT_AVAILABLE_TEXT = 'n/a';
